import GreyTable from '../../../../components/Tables/GreyTable'
import { Col, Row } from 'react-bootstrap'
import { useSelector } from 'react-redux';
import Cookies from "js-cookie";
import { Loader } from '../../../../components/Loader/Loader';
import { useTheme } from '../../../../Themecontext/Themecontext';

export const BillingDetail = ({ Muldata }) => {

  const formatIndianRupee2 = (amount) =>
    new Intl.NumberFormat("en-IN", {
      currency: "INR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount ?? 0);

  const formatIndianRupee1 = (amount) =>
    new Intl.NumberFormat("en-IN", {
      currency: "INR",
      minimumFractionDigits: 1,
      maximumFractionDigits: 1,
    }).format(amount ?? 0);

  const formatIndianRupee = (amount) =>
    new Intl.NumberFormat("en-IN", {
      currency: "INR",
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    }).format(amount ?? 0);

  const { AccountToPGroupListData } = useSelector((state) => state.PartyProfileSlice);
  const { DlvDetailData } = useSelector((state) => state.PartyProfileSlice);


  const { Colourdata } = useSelector((state) => state.ClientLogin);
  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "GRAYNEW");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "GRAYDARKNEW",
  );

  const { theme } = useTheme();
  const isdark = theme;


  const columns = [
    // { Header: "Chart", accessor: "chartButton", width: "60px" },
    { key: "srNumber", label: "Sr No.", align: "center", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "BillNo", label: "GP No.", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "date", label: "Date", align: "center", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "ItemName", label: "Quality Name", align: "left", colors: isdark === "light" ? iscolour?.Colour2 : iscolourDark?.Colour2 },
    { key: "Days", label: "Days", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "Process", label: "Process", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "ChallanNo", label: "Challan No", align: "right", rupees: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "LotNo", label: "Lot. No.", align: "right", rupees: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "Meter", label: "Meter", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "Taka", label: "Taka", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "Tp", label: "TP", align: "right", colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "Rate", label: "Rate", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "GrossAmount", label: "Gross Amount", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "TaxableAmount", label: "Taxable Amount", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "SGST", label: "SGST", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "CGST", label: "CGST", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
    { key: "NetAmount", label: "Net Amount", align: "right", format: true, colors: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour5 },
  ];

  if (DlvDetailData === null) {
    return (
      <div className="flex justify-center items-center h-screen text-xl text-green-700">
        <Loader />
      </div>
    );
  }



  return (
    <>
      <div>
        <Row>
          <Col>
            <>
              <div
                style={{
                  borderRadius: "12px",
                  overflow: "hidden",
                  boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                  marginTop: "20px"
                }}
              >
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    color:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour8,
                    padding: "14px",
                  }}
                >
                  <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px", fontWeight: "700" }}>
                    MERGING
                  </h2>
                </div>
                {DlvDetailData?.DlvDate && DlvDetailData?.DlvDate?.length > 0 ? (
                  <GreyTable
                    columns={columns}
                    data={DlvDetailData?.DlvDate?.map((row, index, arr) => {
                      const totalLength = arr.length.toString().length;
                      return {
                        id: index,
                        // srNumber: (index + 1).toString().padStart(totalLength, "0"),
                        ...row,
                        date: new Date(row.date).toLocaleDateString("en-GB"),
                        Days: formatIndianRupee(row.Days),
                        ChallanNo: formatIndianRupee(row.ChallanNo),
                        LotNo: formatIndianRupee(row.LotNo),
                        Meter: formatIndianRupee2(row.Meter),
                        Taka: formatIndianRupee(row.Taka),
                        Tp: formatIndianRupee(row.Tp),
                        Rate: formatIndianRupee1(row.Rate),
                        GrossAmount: formatIndianRupee2(row.GrossAmount),
                        TaxableAmount: formatIndianRupee2(row.TaxableAmount),
                        SGST: formatIndianRupee2(row.SGST),
                        CGST: formatIndianRupee2(row.CGST),
                        NetAmount: formatIndianRupee2(row.NetAmount),
                      };
                    })}
                    iscolourDark={iscolourDark}
                    iscolour={iscolour}
                  />
                ) : (
                  <p
                    style={{
                      color: "#ff0000",
                      fontWeight: "bold",
                      padding: "10px",
                    }}
                  >
                    Data Not Found
                  </p>
                )}
              </div>
            </>


            {Muldata?.map((el) => {
              return (
                <>
                  <div
                    style={{
                      borderRadius: "12px",
                      overflow: "hidden",
                      boxShadow: "0 4px 10px rgba(0,0,0,0.27)",
                      marginTop: "15px"
                    }}
                  >
                    <div
                      style={{
                        backgroundColor:
                          isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour1,
                        color:
                          isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour8,
                        padding: "14px",
                      }}
                    >
                      <h2 style={{ fontSize: "18px", margin: 0, letterSpacing: "1px", fontWeight: "700" }}>
                        {AccountToPGroupListData?.Data?.find(
                          (nel) => Number(el.group) === Number(nel.ProductionGroupMstID)
                        )?.ProductionGroupMstName || `Group ${el.group}`}
                      </h2>
                    </div>

                    {el?.DlvDate && el?.DlvDate?.length > 0 ? (
                      <GreyTable
                        columns={columns}
                        data={el?.DlvDate?.map((row, index, arr) => {
                          const totalLength = arr.length.toString().length;
                          return {
                            id: index,
                            srNumber: (index + 1)
                              .toString()
                              .padStart(totalLength, "0"),
                            ...row,
                            date: new Date(row.date).toLocaleDateString("en-GB"),
                            Days: formatIndianRupee(row.Days),
                            ChallanNo: formatIndianRupee(row.ChallanNo),
                            LotNo: formatIndianRupee(row.LotNo),
                            Meter: formatIndianRupee2(row.Meter),
                            Taka: formatIndianRupee(row.Taka),
                            Tp: formatIndianRupee(row.Tp),
                            Rate: formatIndianRupee1(row.Rate),
                            GrossAmount: formatIndianRupee2(row.GrossAmount),
                            TaxableAmount: formatIndianRupee2(row.TaxableAmount),
                            SGST: formatIndianRupee2(row.SGST),
                            CGST: formatIndianRupee2(row.CGST),
                            NetAmount: formatIndianRupee2(row.NetAmount),
                          };
                        })}
                        iscolourDark={iscolourDark}
                        iscolour={iscolour}
                      />
                    ) : (
                      <p
                        style={{
                          color: "#ff0000",
                          fontWeight: "bold",
                          padding: "10px",
                        }}
                      >
                        Data Not Found
                      </p>
                    )}
                  </div>
                </>
              );
            })}
          </Col >
        </Row>
      </div>
    </>
  )
}


